(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.Companies = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, DataSourceFilterGroupIds) {
        return {
            name: 'Companies',
            description: 'access to company attributes',

            storageDimensions: [
                'companyId'
            ],

            availableDimensions: [
                'companySetId',
                'source'
            ],

            fields: {
                // companyId level fields.
                companyId: {
                    dataType: dataType.INTEGER
                },
                name: {
                    dataType: dataType.STRING,
                    name: 'Company'
                },
                url: {
                    name: 'Profile URL',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },

                // source specific fields.
                presenceId: {
                    dataType: dataType.INTEGER
                },
                handle: {
                    dataType: dataType.STRING,
                    name: 'Handle'
                },
                icon_url: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                overview: {
                    name: 'Bio Description',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },
                overview_length: {
                    name: 'Bio Description Length',
                    collection: collection.GENERAL,
                    dataType: dataType.INTEGER
                },
                display_name: {
                    name: 'Full Name',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },
                display_name_length: {
                    name: 'Full Name Length',
                    collection: collection.GENERAL,
                    dataType: dataType.INTEGER
                },
                location: {
                    name: 'Location',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },
                keywords: {
                    name: 'Keywords',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },
                restricted_profile: {
                    dataType: dataType.BOOLEAN
                },

                // web-specific fields
                website_title: {
                    name: 'Title',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },
                website_title_length: {
                    name: 'Title Length',
                    collection: collection.GENERAL,
                    dataType: dataType.INTEGER
                },
                overview_length_rating: {
                    name: 'Meta Description Size Rating',
                    collection: collection.GENERAL,
                    dataType: dataType.STRING
                },

                // bookkeeping dates
                earliestPostData: {
                    dataType: dataType.DATE
                },
                earliestPresenceData: {
                    dataType: dataType.DATE
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.source
            ]
        };
    }
})();
